import { render, staticRenderFns } from "./publishVideo.vue?vue&type=template&id=2c084c7e&scoped=true&"
import script from "./publishVideo.vue?vue&type=script&lang=js&"
export * from "./publishVideo.vue?vue&type=script&lang=js&"
import style0 from "./publishVideo.vue?vue&type=style&index=0&id=2c084c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c084c7e",
  null
  
)

export default component.exports